<template>
				<div class="main-content">
					<!-- h2 class="large">特集から探す</h2>
					<ul class="list_special">
          <li>
            <router-link :to="{ name: 'catlist', params: { Name: '新入荷'}}"><img src="/images/special01.jpg"><label>新入荷商品</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'catlist', params: { Name: 'おすすめ'}}"><img src="/images/special02.jpg"><label>おすすめ商品</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'catlist', params: { Name: '災害'}}"><img src="/images/special03.jpg"><label>災害支援商品</label></router-link>
          </li>
          </ul -->

					<h2 class="large">機種一覧から探す</h2>
					<ul class="list_category">
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '掘削機'}}">
            <img :src="baseUrl + '_img/catalog/category01.jpg'" @error="onImageError"><label>掘削機（バックホー・油圧ショベル）</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '解体'}}">
            <img :src="baseUrl + '_img/catalog/category19.jpg'" @error="onImageError"><label>解体・林業・アタッチメント</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: 'レンタカー'}}">
            <img :src="baseUrl + '_img/catalog/category02.jpg'" @error="onImageError"><label>レンタカー</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '高所'}}">
            <img :src="baseUrl + '_img/catalog/category04.jpg'" @error="onImageError"><label>高所作業車</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '道路機械'}}">
            <img :src="baseUrl + '_img/catalog/category03.jpg'" @error="onImageError"><label>道路機械</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '整地'}}">
            <img :src="baseUrl + '_img/catalog/category09.jpg'" @error="onImageError"><label>整地・運搬機械</label></router-link>
          </li>
          </ul>
          <ul class="list_category2">
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '水中ポンプ'}}">
            <img :src="baseUrl + '_img/catalog/category10.jpg'" @error="onImageError"><label>水中ポンプ・水処理機械</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '発電'}}">
            <img :src="baseUrl + '_img/catalog/category05.jpg'" @error="onImageError"><label>発電・溶接・照明機器</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: 'コンプレッサ'}}">
            <img :src="baseUrl + '_img/catalog/category06.jpg'" @error="onImageError"><label>コンプレッサ・エア機械</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: 'ハウス'}}">
            <img :src="baseUrl + '_img/catalog/category07.jpg'" @error="onImageError"><label>ハウス・備品</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '通信'}}">
            <img :src="baseUrl + '_img/catalog/category08.jpg'" @error="onImageError"><label>通信計測機器</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist2', params: { Spec: '保安'}}">
            <img :src="baseUrl + '_img/catalog/category20.jpg'" @error="onImageError"><label>保安商品</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: 'コンクリート機器'}}">
            <img :src="baseUrl + '_img/catalog/category11.jpg'" @error="onImageError"><label>コンクリート機器</label></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '汎用'}}">
            <img :src="baseUrl + '_img/catalog/category12.jpg'" @error="onImageError"><label>汎用機器</label></router-link>
          </li>
          </ul>
      
					<h2 class="large">参考資料</h2>
          <ul class="list_document">
            <li>
              <a href="/../document/general-conditions.html"><img :src="baseUrl + '_img/catalog/rental.jpg'" @error="onImageError"><label>レンタル約款</label></a>
            </li>
            <li>
              <a href="/../document/rental-support.html"><img :src="baseUrl + '_img/catalog/support.jpg'" @error="onImageError"><label>レンタル物件サポート特約制度</label></a>
            </li>
            <li>
              <a href="/../document/special-contract.html"><img :src="baseUrl + '_img/catalog/guarantee.jpg'" @error="onImageError"><label>レンタル保障制度</label></a>
            </li>
            <li>
              <a href="/../document/law.html"><img :src="baseUrl + '_img/catalog/law.jpg'" @error="onImageError"><label>法規</label></a>
            </li>
            <li>
              <a href="/../document/qualification.html"><img :src="baseUrl + '_img/catalog/certificate.jpg'" @error="onImageError"><label>資格</label></a>
            </li>
            <li>
              <a href="/../document/unit.html"><img :src="baseUrl + '_img/catalog/unit.jpg'" @error="onImageError"><label>単位</label></a>
            </li>
            <li>
              <a href="/../document/guide.html"><img :src="baseUrl + '_img/catalog/guide.jpg'" @error="onImageError"><label>ご利用ガイド</label></a>
            </li>
          </ul>
        </div>
</template>

<script>
  export default {
    data: function () {
      return {
        baseUrl: process.env.BASE_URL,
        noImage: process.env.BASE_URL + '_img/noimage.png'
      }
    },
    mounted: function (){
      this.$parent.category_id = null
    },
    methods: {
      onImageError: function (event) {
        event.target.onerror = null
        event.target.src = this.noImage
      }
    },
    watch: {
    }
  }
</script>
